import { useState } from 'react'
import type { Song } from '../data/songs'
import { mediaUrl } from '../lib/media'

export function CoverArt({ song }: { song: Song }) {
  const [failed, setFailed] = useState(false)
  const hasCover = Boolean(song.cover)

  if (!hasCover || failed) {
    return (
      <div className="card-placeholder">
        <span>{song.title}</span>
      </div>
    )
  }

  return (
    <img
      src={mediaUrl(song.cover!)}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  )
}
